// extracted by mini-css-extract-plugin
export default {"wrapper":"HeaderSideBar_wrapper__cJa5m","container":"HeaderSideBar_container__MI7oy","content":"HeaderSideBar_content__fDqkg"};